
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class ModeDialog extends Serenity.EntityDialog<ModeRow, any> {
        protected getFormKey() { return ModeForm.formKey; }
        protected getIdProperty() { return ModeRow.idProperty; }
        protected getLocalTextPrefix() { return ModeRow.localTextPrefix; }
        protected getNameProperty() { return ModeRow.nameProperty; }
        protected getService() { return ModeService.baseUrl; }
        protected getDeletePermission() { return ModeRow.deletePermission; }
        protected getInsertPermission() { return ModeRow.insertPermission; }
        protected getUpdatePermission() { return ModeRow.updatePermission; }

        protected form = new ModeForm(this.idPrefix);

    }
}